import React from 'react';
import moment from 'moment';
import { Row, Col, CardHeader, Card, CardBody } from 'reactstrap';

const AssociateActivity = ({
  checklistData,
  attendanceData,
  pickRatesData,
}) => {
  const [activeTab, setActiveTab] = React.useState('checklist');

  return (
    <Card className="card-h-100 rounded-2 mt-4">
      <CardHeader className="my-2 d-flex flex-row justify-content-between">
        <div>
          <h6 className="card-title mb-1">My Activity</h6>
        </div>
        <div className="d-flex justify-content-start">
          <div
            className="flex-shrink-0"
            onClick={() => setActiveTab('checklist')}
          >
            <div
              style={
                activeTab === 'checklist'
                  ? {
                      cursor: 'pointer',
                      marginRight: '1.5rem',
                      paddingBottom: '1rem',
                      borderBottom: '5px #5156BE solid',
                    }
                  : {
                      cursor: 'pointer',
                      marginRight: '1.5rem',
                      paddingBottom: '1rem',
                    }
              }
            >
              <strong
                className={
                  activeTab === 'checklist' ? 'text-brand' : 'text-muted'
                }
              >
                Checklist
              </strong>
            </div>
          </div>
          <div
            className="flex-shrink-0"
            onClick={() => setActiveTab('attendance')}
          >
            <div
              style={
                activeTab === 'attendance'
                  ? {
                      cursor: 'pointer',
                      marginRight: '1.5rem',
                      paddingBottom: '1rem',
                      borderBottom: '5px #5156BE solid',
                    }
                  : {
                      cursor: 'pointer',
                      marginRight: '1.5rem',
                      paddingBottom: '1rem',
                    }
              }
            >
              <strong
                className={
                  activeTab === 'attendance' ? 'text-brand' : 'text-muted'
                }
              >
                Attendance
              </strong>
            </div>
          </div>
          <div
            className="flex-shrink-0"
            onClick={() => setActiveTab('pickrate')}
          >
            <div
              style={
                activeTab === 'pickrate'
                  ? {
                      cursor: 'pointer',
                      paddingBottom: '1rem',
                      borderBottom: '5px #5156BE solid',
                    }
                  : {
                      cursor: 'pointer',
                      paddingBottom: '1rem',
                    }
              }
            >
              <strong
                className={
                  activeTab === 'pickrate' ? 'text-brand' : 'text-muted'
                }
              >
                Pick Rate
              </strong>
            </div>
          </div>
        </div>
      </CardHeader>
      <CardBody className="checklist-card-body">
        {activeTab === 'checklist' ? (
          <div className="activity-container">
            {checklistData.length > 0 ? (
              checklistData.map((item, index) => {
                return (
                  <Row key={index} className="activity-hover">
                    <Col lg={2} md={2} sm={12}>
                      <h6 className="text-muted">{index + 1}</h6>
                    </Col>
                    <Col lg={7} md={7} sm={12}>
                      {item.checklist.map((checklistItem) => (
                        <Row key={checklistItem.id}>
                          <Col>
                            <h6>{checklistItem.question}</h6>
                            <p className="text-muted fs-12">
                              {checklistItem.answer}
                            </p>
                          </Col>
                        </Row>
                      ))}
                    </Col>
                    <Col lg={3} md={3} sm={3}>
                      <span className="text-muted fs-12">
                        {item.date_created}
                      </span>
                    </Col>
                  </Row>
                );
              })
            ) : (
              <p className="text-muted fs-12 text-center">No record found.</p>
            )}
          </div>
        ) : activeTab === 'attendance' ? (
          <div className="activity-container">
            {attendanceData.length > 0 ? (
              attendanceData.map((item, index) => (
                <Row key={index} className="activity-hover">
                  <Col lg={2} md={2} sm={12}>
                    <h6 className="text-muted">{index + 1}</h6>
                  </Col>
                  <Col lg={7} md={7} sm={12}>
                    <h6>{item.attendance_status.time_status}</h6>
                    <p className="text-muted fs-12">
                      {moment(item.time_in).format('HH:mm')} -{' '}
                      {item.time_out
                        ? moment(item.time_out).format('HH:mm')
                        : '00:00'}
                    </p>
                    <p className="text-muted fs-12">
                      {item.timein_location || '--'}
                    </p>
                  </Col>
                  <Col lg={3} md={3} sm={3}>
                    <span className="text-muted fs-12">
                      {moment(item.createdAt).format('DD/MM/YYYY hh:mma')}
                    </span>
                  </Col>
                </Row>
              ))
            ) : (
              <p className="text-muted fs-12 text-center">No record found.</p>
            )}
          </div>
        ) : activeTab === 'pickrate' ? (
          <div className="activity-container">
            {pickRatesData.length > 0 ? (
              pickRatesData.map((item, index) => (
                <Row key={index} className="activity-hover">
                  <Col lg={2} md={2} sm={12}>
                    <h6 className="text-muted">{index + 1}</h6>
                  </Col>
                  <Col lg={7} md={7} sm={12}>
                    <h6>Pick Rate</h6>
                    <p className="text-muted fs-12">{item.pick_rate}</p>
                  </Col>
                  <Col lg={3} md={3} sm={3}>
                    <span className="text-muted fs-12">
                      {moment(item.createdAt).format('DD/MM/YYYY hh:mma')}
                    </span>
                  </Col>
                </Row>
              ))
            ) : (
              <p className="text-muted fs-12 text-center"> No record found.</p>
            )}
          </div>
        ) : (
          ''
        )}
      </CardBody>
    </Card>
  );
};

export default AssociateActivity;
